<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { ethers } from 'ethers'
import { Message } from 'element-ui'
import router from './router';
export default {
    name: "App",
    data() {
      return {
      }
    },
    methods: {
      // async walletConnet() {
      //   let wert = new ethers.providers.Web3Provider(window.ethereum);
      //   const accounts = await wert.send("eth_requestAccounts", []);
      //   console.log(accounts[0])
      //   if(accounts[0].toLowerCase() != localStorage.getItem('userAddress').toLowerCase()) {
      //     Message({
      //       type: 'error',
      //       message: '已切换钱包，请重新授权登录!'
      //     })
      //     setTimeout(() => {
      //       router.push({ path: './login' })
      //     }, 1000)
      //   }
      // },
    },
    created(){
    }
};
</script>

<style> 
html,
body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    widows: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue